import type { GivingTypeEnum, LabelInValue } from 'models';
import { Empty, HandHeartLineIcon } from 'ui';
import { useDebounce } from 'common/hooks';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { EntityList } from 'features/channels/components';
import { useGivingsInfiniteQuery } from '../../../queries';

type P = {
  filter: { organization?: LabelInValue; search?: string; type?: GivingTypeEnum };
  getPathToGivingDetail: (id: string) => string;
};

const GivingsListContent = ({ filter: { organization, search: propertySearch, type }, getPathToGivingDetail }: P) => {
  const { isDebouncing, value: search } = useDebounce(propertySearch);
  const { data, fetchNextPage, hasNextPage, isFetching, isLoading } = useGivingsInfiniteQuery({
    filter: { organizationId: organization?.value, search, type },
    pagination: { pageSize: 12 },
  });

  const pathToEntityDetail = (id: string) => getPathToGivingDetail(id);

  const allGivings = data?.pages.flat().flatMap((givingsPaginated) => givingsPaginated.data);

  return (
    <EntityList
      empty={
        <Empty
          description={{
            subtitle: 'Currently, there is no active giving to display.',
            title: 'No giving found',
          }}
          image={<HandHeartLineIcon />}
        />
      }
      entities={allGivings?.map((giving) => ({
        data: giving,
        type: 'Giving',
      }))}
      fetchNextPage={fetchNextPage}
      getPathToEntityDetail={pathToEntityDetail}
      hasNextPage={hasNextPage}
      isFetching={isFetching}
      isLoading={isDebouncing || isLoading}
    />
  );
};

export default GivingsListContent;
